export default __webpack_public_path__ + "static/on-page-load-071735ceea3002db0ec028d6322bab69.png";